export default "__VITE_IMAGE_ASSET__65684e58__";